import Icon from '@/components/ui/AppIcon';

interface TrendingSectionProps {
  trends: Array<{
    id: number;
    title: string;
    category: string;
    trendingRank: number;
    growthPercentage: string;
  }>;
}

const TrendingSection = ({ trends }: TrendingSectionProps) => {
  return (
    <div className="bg-gradient-to-br from-accent/10 to-primary/10 rounded-xl p-6">
      <div className="flex items-center space-x-3 mb-6">
        <Icon name="FireIcon" size={28} className="text-accent" variant="solid" />
        <h2 className="text-2xl font-heading font-bold text-text-primary">
          Trending Now
        </h2>
      </div>

      <div className="space-y-3">
        {trends.map((trend) => (
          <div
            key={trend.id}
            className="flex items-center space-x-4 p-4 bg-card rounded-lg hover:shadow-warm transition-all duration-200 cursor-pointer group"
          >
            <div className="flex items-center justify-center w-10 h-10 bg-primary text-primary-foreground rounded-full font-bold text-lg">
              {trend.trendingRank}
            </div>

            <div className="flex-1">
              <h4 className="font-heading font-bold text-text-primary group-hover:text-primary transition-colors duration-200">
                {trend.title}
              </h4>
              <p className="text-sm text-text-secondary">{trend.category}</p>
            </div>

            <div className="flex items-center space-x-1 text-success font-medium text-sm">
              <Icon name="ArrowTrendingUpIcon" size={16} />
              <span>{trend.growthPercentage}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrendingSection;